export function getdata() {
	let obj = {
		headData: [{
				title: "用户代码",
				prop: "userCode",
				width: "100"
			},
			{
				title: "用户名称",
				prop: "userName",
				width: "100"
			},
			{
				title: "用户类型",
				prop: "userType",
				width: "100",
				custom: true
			},
			{
				title: "用户状态",
				prop: "state",
				width: "100",
				custom: true
			}, {
				title: "手机",
				prop: "phone",
				width: "100"
			}, {
				title: "邮箱",
				prop: "email",
				width: "100"
			},
			{
				title: "操作 ",
				prop: "cz",
				width: "200",
				fixed: "right",
				custom: true
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},

	}
	return obj
}
